const insuranceInnerNavShadow = document.querySelector('.insurance-cars-inner__left__shadow')

if (insuranceInnerNavShadow) {

    const insuranceInnerNav = document.querySelector('.insurance-cars-inner__left__items')

    function AddShadow() {
        let generalScroll = insuranceInnerNav.scrollWidth - insuranceInnerNav.clientWidth
        if (insuranceInnerNav.scrollWidth <= insuranceInnerNav.clientWidth) {
            insuranceInnerNavShadow.style = "opacity: 0"
        } else {
            insuranceInnerNavShadow.style = "opacity: 1"
        }
        insuranceInnerNav.addEventListener('scroll', function() {
            if (insuranceInnerNav.scrollLeft > generalScroll - 16) {
                insuranceInnerNavShadow.style = "opacity: 0"
            } else {
                insuranceInnerNavShadow.style = "opacity: 1"
            }
        })
    }

    window.addEventListener('load', function() {
        AddShadow()
    })
    window.addEventListener('resize', function() {
        AddShadow()
    })

}